import React, { Component } from "react";
// import { img1 } from "./programming-animate.svg";
// import { Image } from "react-bootstrap";
import { ReactComponent as Logo } from "./programming-animate.svg";

export default class FullStackImg extends Component {
  render() {
    // const theme = this.props.theme;
    return (
      // <img src={img1} alt="Full Stack Development" />
      <Logo />
    );
  }
}
